import React from "react";
import { Formik } from "formik";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import base_background from "../../assets/Base (1).png";
import main_logo from "../../assets/SM_Full_White-100 1 (1).png";
import arrow_forward from "../../assets/arrow_forward.png";
import arrow from "../../assets/Vector (1).png";
import passwordIcon from "../../assets/visibility_lock (1).png";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import edit from "../../assets/edit.png";
// import { useAlert } from "react-alert";
import { useAlert } from "components/UI_components/Alert";
import { BASE_URL } from "utils/constant";
import { Loader } from "lucide-react";

export default function OtpScreen() {
  const [counter, setCounter] = useState(60);
  const otpInputRefs = useRef([]);
  const [isLoading, setIsLoading] = useState(false);

  // Initialize refs for the OTP inputs
  useEffect(() => {
    otpInputRefs.current = Array(4)
      .fill(null)
      .map((_, index) => otpInputRefs.current[index] || React.createRef());
  }, []);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const { addAlert } = useAlert();
  const navigate = useNavigate();
  const user_details = useSelector((state) => state.auth);

  const [passwordVisible, setPasswordVisible] = useState(false);

  async function fetchUserDataAndRedirect() {
    try {
      const accessToken = localStorage.getItem("access");
      const response = await fetch(`${BASE_URL}/auth/user-details-of-user/`, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + accessToken,
        }),
        redirect: "follow",
      });

      if (!response?.ok) {
        navigate("/profession");
        return;
      }

      const result = await response.json();

      if (!result.status) {
        if (result.message === "No user details found for this email") {
          // First time login - redirect to welcome page
          navigate("/profession");
        } else {
          navigate("/login");
        }
        return;
      }

      // User has details - set localStorage and redirect based on profession
      const userData = result.data;
      localStorage.setItem("user", JSON.stringify(userData));

      if (userData?.profession === "owner") {
        localStorage.setItem("isOwner", "true");
        localStorage.setItem("isIndividual", "false");
        navigate("/");
      } else {
        localStorage.setItem("isOwner", "false");
        localStorage.setItem("isIndividual", "true");
        navigate("/dashboard/projects");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      addAlert(error?.message || "Failed to fetch user data", "error");
      navigate("/login");
    }
  }

  async function create_token(email, password) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var raw = JSON.stringify({
      email: email,
      password: password,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(`${BASE_URL}/token/create/`, requestOptions);
      const result = await response.json();
      if (result?.access) {
        localStorage.setItem("access", result.access);
        localStorage.setItem("refresh", result.refresh);
        fetchUserDataAndRedirect();
      } else {
        // alert.error(result?.message || "Failed to create token");
        addAlert(result?.message || "Failed to create token", "error");
      }
    } catch (error) {
      console.error("error", error);
      // alert.error(error?.message || "Failed to connect to server");
      addAlert(error?.message || "Failed to connect to server", "error");
    }
  }

  async function verifyOtp(email, Otp) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var raw = JSON.stringify({
      email: email.toLowerCase(),
      otp: Otp,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    setIsLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/auth/verify/`, requestOptions);
      const res = await response.json();

      // console.log(res);

      if (res?.status) {
        create_token(email.toLowerCase(), user_details?.password);
      } else {
        // alert.error("Error", res.message);
        addAlert(res?.message || "Error", "error");
      }
    } catch (error) {
      console.error("error", error);
      // alert.error(error.message);
      addAlert(error?.message || "Failed to connect to server", "error");
    } finally {
      console.log("Otp verified");
      setIsLoading(false);
    }
  }

  async function resendOtp(email) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var raw = JSON.stringify({
      email: email,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${BASE_URL}/auth/resendotp/`,
        requestOptions
      );
      const result = await response.text();
      if (result?.status) {
        // alert.success("OTP sent successfully");
        addAlert("OTP sent successfully", "success");
      }
    } catch (error) {
      // alert.error(error?.message);
      addAlert(error?.message || "Failed to connect to server", "error");
    }
  }

  const loginValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter a valid email")
      .required("Email Address is Required"),
    otp: yup
      .array()
      .of(
        yup
          .string()
          .length(1, "Invalid OTP")
          .test("is-digit", "Enter valid digit", (value) => {
            return /^\d$/.test(value);
          })
      )
      .test("is-complete", "Enter valid digit", (value) => {
        return value.every((digit) => digit !== "");
      }),
  });

  const formik = useFormik({
    initialValues: {
      email: user_details.email,
      otp: ["", "", "", ""],
    },
    validationSchema: loginValidationSchema,
    onSubmit: (values) => {
      let OTP = "";
      values.otp.forEach((digit) => {
        OTP += digit;
      });
      verifyOtp(values.email, OTP);
    },
  });

  // Handle OTP input with auto-focus
  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    // Only allow numerical input
    if (!/^\d*$/.test(value)) return;

    // Update the OTP value
    const newOtp = [...formik.values.otp];

    // Take only the last character if multiple characters are pasted
    newOtp[index] = value.slice(-1);
    formik.setFieldValue("otp", newOtp);

    // Auto-focus to next input if a digit was entered
    if (value && index < 3) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace in OTP input
  const handleKeyDown = (e, index) => {
    // If backspace is pressed and current field is empty, move to previous field
    if (e.key === "Backspace" && !formik.values.otp[index] && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
  };

  // Handle paste event for OTP
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const digits = pastedData.match(/\d/g);

    if (digits && digits.length) {
      // Fill the OTP fields with pasted digits
      const newOtp = [...formik.values.otp];
      for (let i = 0; i < Math.min(digits.length, 4); i++) {
        newOtp[i] = digits[i];
      }
      formik.setFieldValue("otp", newOtp);

      // Focus the next unfilled input or the last input if all are filled
      const nextIndex = Math.min(digits.length, 3);
      otpInputRefs.current[nextIndex].focus();
    }
  };

  useEffect(() => {
    // console.log(user_details);
  });

  const [editEmail, setEditEmail] = useState(false);

  return (
    <div
      className=""
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          position: "absolute",
          zIndex: -3,
          height: "100%",
          width: "50%",
          top: "0px",
          left: "0px",
        }}
      >
        <img
          src={base_background}
          alt=""
          style={{
            height: "140%",
            width: "140%",
            objectFit: "cover",
            position: "relative",
            top: "-50px",
            left: "-50px",
          }}
        />
      </div>
      <div
        style={{
          position: "absolute",
          zIndex: -3,
          height: "100%",
          width: "50%",
          top: "0px",
          left: "0px",
        }}
      >
        <img
          src={arrow}
          alt=""
          style={{
            height: "115%",
            width: "115%",
            top: "0px",
            left: "-70px",
            objectFit: "contain",
            position: "relative",
            opacity: "0.5",
          }}
        />
      </div>
      <div className="flex flex-col align-middle items-center justify-center w-[50%]">
        <span className="py-5 font-extrabold text-neutral-900 text-2xl">
          <img src={main_logo} alt="" width="90%" />
        </span>
        <span
          className="font-extrabold text-neutral-900 mt-[-2]"
          style={{
            fontSize: "28px",
            color: "#ffffff",
            fontWeight: 400,
            opacity: 0.8,
            letterSpacing: "0.1em",
            textAlign: "center",
          }}
        >
          Build Smarter,Faster,Better
        </span>
      </div>
      <div
        style={{
          width: "50%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          position: "relative",
          top: "70px",
          right: "50px",
        }}
      >
        <form
          onSubmit={formik.handleSubmit}
          className="flex flex-col align-middle justify-between px-10 pb-5"
          style={{ width: "80%" }}
        >
          <div className="flex flex-col">
            <span
              className="py-5 font-extrabold text-purple-800 text-2xl"
              style={{
                color: "#3B0069",
                fontSize: "32px",
                fontWeight: 700,
              }}
            >
              Create an Account
            </span>
            <span
              style={{
                fontSize: "16px",
                color: "black",
                fontWeight: 200,
                opacity: 0.8,
                marginTop: "-12px",
              }}
            >
              Already have an account?{" "}
              <Link
                to="/login"
                className="text-purple-800"
                style={{ textDecoration: "underline" }}
              >
                Sign in
              </Link>
            </span>
            <span
              className="py-2 "
              style={{
                fontSize: "24px",
                color: "#4B5563",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              Enter OTP
            </span>

            <span className="pt-3 text-neutral-800 font-medium mb-3">
              Enter the 4 Digit code sent to your email
            </span>
            <div
              style={{
                position: "relative",
                width: "80%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <input
                type="email"
                name="email"
                className="bg-gray-200 rounded px-4 py-6"
                placeholder="Enter email here"
                disabled={!editEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                style={{
                  width: "100%",
                  height: "56px",
                  paddingBottom: "0px",
                  fontWeight: "500",
                  color: "#3B0069",
                  fontSize: "16px",
                }}
              />

              <span
                className="text-neutral-700 font-medium"
                style={{
                  position: "absolute",
                  top: "6px",
                  left: "16px",
                  fontSize: "12px",
                }}
              >
                Verification code sent to{" "}
              </span>
              <span
                onClick={() => {
                  setEditEmail(true);
                }}
                style={{
                  position: "absolute",
                  right: "16px",
                  top: "13px",
                  width: "32px",
                  background: "white",
                  borderRadius: "50%",
                  height: "32px",
                  display: "flex",
                  padding: "5px",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignContent: "space-around",
                  alignItems: "center",
                }}
              >
                <img
                  src={edit}
                  alt="edit"
                  style={{
                    cursor: "pointer",
                  }}
                  className="w-5 h-5"
                />
              </span>
              {formik.touched.email && formik.errors.email && (
                <span
                  style={{
                    fontSize: 10,
                    color: "red",
                    position: "absolute",
                    bottom: "-13px",
                    left: "2px",
                  }}
                >
                  {formik.errors.email}
                </span>
              )}
            </div>
            <div
              className="flex flex-row"
              style={{
                marginTop: "32px",
                columnGap: "13px",
                marginLeft: "-6px",
              }}
            >
              {formik.values.otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  name={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onPaste={index === 0 ? handlePaste : undefined}
                  ref={(el) => (otpInputRefs.current[index] = el)}
                  autoFocus={index === 0}
                  className="border mx-1"
                  style={{
                    width: "17%",
                    height: "48px",
                    fontWeight: "600",
                    color: "#232323",
                    fontSize: "26px",
                    textAlign: "center",
                    borderRadius: "8px",
                    backgroundColor: "#F3F4F6",
                    border: "1px solid #E5E7EB",
                  }}
                />
              ))}
            </div>
            {formik.touched.otp && formik.errors.otp && (
              <span
                style={{
                  fontSize: 10,
                  color: "red",
                  bottom: "-13px",
                  left: "2px",
                }}
              >
                {formik.errors.otp[0]
                  ? formik.errors.otp[0]
                  : formik.errors.otp[1]
                    ? formik.errors.otp[1]
                    : formik.errors.otp[2]
                      ? formik.errors.otp[2]
                      : formik.errors.otp[3]
                        ? formik.errors.otp[3]
                        : ""}
              </span>
            )}
          </div>

          <span
            className="pt-3 text-neutral-800 font-medium"
            style={{ fontSize: "12px" }}
          >
            Didn't receive OTP?{" "}
          </span>
          <span
            className="text-purple-950 font-medium"
            style={{ fontSize: "14px" }}
          >
            <span
              style={{
                textDecoration: "underline",
                cursor: counter <= 0 ? "pointer" : "default",
              }}
              onClick={() => {
                if (counter <= 0) {
                  resendOtp(formik.values.email);
                  setCounter(60);
                }
              }}
            >
              Resend OTP
            </span>{" "}
            in {counter} seconds
          </span>

          <div className="w-full mt-14" style={{ width: "80%" }}>
            <button
              type="submit"
              className={`py-3 px-8 rounded-lg w-full justify-center items-center flex flex-row gap-4 text-center ${formik.isValid && !isLoading ? "bg-purple-950" : "bg-gray-400"
                }`}
              disabled={!formik.isValid || isLoading}
            >
              <span className=" text-white text-lg">Verify Email ID</span>
              {isLoading ? (
                <Loader className="h-5 w-5 animate-spin" />
              ) : (
                <img
                  src={arrow_forward}
                  alt=""
                  className="w-6 h-6"
                  style={{ background: "#58267F", borderRadius: "50%" }}
                />
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
